/**
 * CombineAutocomplete
 * 
 * @Author: Focci
 * @Date: 2023-09-29 11:00:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 11:00:56
 */

// import PropTypes from 'prop-types'
import Autocomplete from '@page/common/filter/Autocomplete'
import useApp from '@hook/useApp'
import { debounce } from 'lodash-es'
import { useCallback } from 'react'
import { renderOption, uniqOptions } from './lib'
import { CombineProvider, useCombine } from './context'

function CombineAutocompleteBody({
  onChange = () => {},
  optionPrevFilter = (d) => d,
  ...autocompleteProps
}) {
  const { isMobile } = useApp()
  const { options, loading, getOptions } = useCombine()

  // Change
  const handleChange = useCallback((e, val, reason) => {
    const data = uniqOptions(val)
    onChange(e, data, reason)
  }, [onChange])

  const handleInputChange = debounce((e) => {
    getOptions(e.target.value, optionPrevFilter)
  }, 500)
  
  return (
    <Autocomplete
      multiple
      limitTags={isMobile ? 2 : 4}
      wraperClassName="rounded-r-none"
      loading={loading}
      options={options}
      onInputChange={handleInputChange}
      renderOption={renderOption}
      groupBy={(option) => option.typeName}
      getOptionLabel={(option) => option.label}
      onChange={handleChange}
      {...autocompleteProps}
    />
  )
}

export default function CombineAutocomplete(props) {
  const { type } = props
  return (
    <CombineProvider type={type}>
      <CombineAutocompleteBody {...props} />
    </CombineProvider>
  )
}
